import { AnimatePresence } from 'framer-motion';
import {
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';

import ForgotPage from '../pages/ForgotPassword';
import LoginPage from '../pages/Login';
import NotFound from '../pages/NotFound';
import ResetPassword from '../pages/ResetPassword';

function LoginRoute() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes
        location={location}
        key={location.pathname}
      >
        <Route path="/" element={<LoginPage />} />
        <Route path="/forgot" element={<ForgotPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
}

export default LoginRoute;
